const StatusIndicatorInvisible = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="52" viewBox="0 0 26 52" fill="none">
      <path
        d="M10.2111 41.1056C8.85601 40.428 8 39.043 8 37.5279V11.2361C8 9.74931 9.56462 8.78231 10.8944 9.44721L13.7889 10.8944C15.144 11.572 16 12.9571 16 14.4721V40.7639C16 42.2507 14.4354 43.2177 13.1056 42.5528L10.2111 41.1056Z"
        fill="transparent"
      />
    </svg>
  )
}

export { StatusIndicatorInvisible }
